var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpCircle = function SvgArrowUpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22C6.477 22 2 17.522 2 11.999s4.477-10 10-10 10 4.477 10.001 10S17.523 22 12 22m0-1.2a8.802 8.802 0 1 0 0-17.603A8.802 8.802 0 0 0 12 20.8m0-4.541a.5.5 0 0 1-.499-.5V9.446l-2.908 2.907a.5.5 0 0 1-.706-.707l3.76-3.76a.496.496 0 0 1 .677-.023l.03.024 3.76 3.76a.5.5 0 0 1-.707.706L12.5 9.445v6.316a.5.5 0 0 1-.499.499"
  })));
};
export default SvgArrowUpCircle;